import React, {Fragment} from "react";
import classNames from 'classnames';

import MatchAndEventMatchReportCard from "./MatchAndEventMatchReportCard";
import ResultCard from '../matches_and_events/cards/ResultCard';

import '../../../../assets/sass/pages/match-and-event-match-report/match-result-card.scss';
import Divider from "../../../ui/Divider";
import {ProgressBar} from "react-bootstrap";
import CircularLabelProgressBar from "../../../ui/progress_bars/CircularLabelProgressBar";

class MatchResultCard extends MatchAndEventMatchReportCard {
    /**
     * Renders the header of the card component.
     * @returns {React.ReactNode} The card header component.
     */
    renderHeader = () => "Match Result";

    /**
     * Renders the body of the card component.
     * @returns {React.ReactNode} The card body component.
     */
    renderBody = () => {
        return (
            <Fragment>
                {this.renderTeams()}
                {this.renderGoals()}
                {this.renderShotsOnGoal()}
                {this.renderBallPossession()}
            </Fragment>
        );
    };

    renderTeams = () => {
        const {team1, team2} = this.props;
        return <MatchResultCard.Teams team1={team1} team2={team2}/>;
    };

    renderGoals = () => {
        const {team1, team2} = this.props;
        return <MatchResultCard.Goals team1={team1} team2={team2}/>;
    };

    renderShotsOnGoal = () => {
        const {team1, team2} = this.props;
        return <MatchResultCard.ShotsOnGoal team1={team1} team2={team2}/>;
    };

    renderBallPossession = () => {
        const {team1, team2} = this.props;
        return <MatchResultCard.BallPossession team1={team1} team2={team2}/>;
    };


    /**
     * Returns the classes of the card component.
     * @returns {string} The card classes.
     */
    cardClasses = () => classNames('match-and-event-match-report-card', 'match-result-card');
}

MatchResultCard.Teams = props => <ResultCard.Teams {...props}/>;
MatchResultCard.Goals = props => <ResultCard.Goals {...props}/>;
MatchResultCard.ShotsOnGoal = props => {
    const {team1, team2} = props;
    const {stats: team1Stats} = team1;
    const {stats: team2Stats} = team2;

    const team1ShotsOnGoal = team1Stats.shotsOnGoal;
    const team2ShotsOnGoal = team2Stats.shotsOnGoal;

    const title = 'Shots on Goal';

    const min = 0;
    const max = 100;

    return (
        <div className="shots-on-goal">
            <div className="team left">
                <div className="shots-on-goal--title">{title}</div>
                <MatchResultCard.CircularLabelProgressBar now={team1ShotsOnGoal} color="secondary-light"/>
                <div className="axis"><span> {min}</span> <span>{max}</span></div>
            </div>
            <Divider show={true} direction="vertical"/>
            <div className="team right">
                <div className="shots-on-goal--title">{title}</div>
                <MatchResultCard.CircularLabelProgressBar now={team2ShotsOnGoal} color="secondary-light"/>
                <div className="axis"><span> {min}</span> <span>{max}</span></div>
            </div>
        </div>
    );
};
MatchResultCard.BallPossession = props => {
    const {team1, team2} = props;
    const {stats: team1Stats} = team1;
    const {stats: team2Stats} = team2;

    const team1BallPossession = team1Stats.ballPossession;
    const team2BallPossession = team2Stats.ballPossession;

    const title = 'Ball Possession';

    const min = '0%';
    const max = '100%';

    return (
        <div className="ball-possession">
            <div className="team left">
                <div className="ball-possession--title">{title}</div>
                <MatchResultCard.CircularLabelProgressBar now={team1BallPossession} color="primary-dark"/>
                <div className="axis"><span> {min}</span> <span>{max}</span></div>
            </div>
            <Divider show={true} direction="vertical"/>
            <div className="team right">
                <div className="ball-possession--title">{title}</div>
                <MatchResultCard.CircularLabelProgressBar now={team2BallPossession} color="primary-dark"/>
                <div className="axis"><span> {min}</span> <span>{max}</span></div>
            </div>
        </div>
    );
};

MatchResultCard.CircularLabelProgressBar = CircularLabelProgressBar;
export default MatchResultCard;
